import React,{Component} from "react";


class verificationPage extends Component{

    render() {
    return(
    <div>
    <section className="menu cid-qTkzRZLJNu" once="menu" id="menu1-3">

            <nav
                className="navbar navbar-expand beta-menu navbar-dropdown align-items-center navbar-fixed-top navbar-toggleable-sm">
                <button className="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse"
                        data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                        aria-expanded="false" aria-label="Toggle navigation">
                    <div className="hamburger"/>
                </button>
                <div className="menu-logo">
                    <div className="navbar-brand">
                <span className="navbar-logo">
                    <a href="https://mobirise.com">
                         <img
                             src="assets/images/kisspng-blockchain-vector-graphics-computer-icons-illustra-flvr-calculator-chasing-coins-5bf69839402611.9278574715428874812628-220x220.png"
                             alt="KeyBlock" title="" style={{height: '3.8rem'}}/>
                    </a>
                </span>
                        <span className="navbar-caption-wrap"><a className="navbar-caption text-white display-7">KeyBlock<br/></a></span>
                    </div>
                </div>
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav nav-dropdown" data-app-modern-menu="true">
                        <li className="nav-item">
                            <a className="nav-link link text-white display-7" href="#">
                                <span className="mbri-home mbr-iconfont mbr-iconfont-btn"/>
                                Services
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link link text-white display-7" href="#">
                                <span className="mbri-search mbr-iconfont mbr-iconfont-btn"/>
                                About Us
                            </a>
                        </li>
                    </ul>
                    <div className="navbar-buttons mbr-section-btn"><a
                        className="btn btn-sm btn-success display-7" href="#"><span
                        className="mbri-sites mbr-iconfont mbr-iconfont-btn"/>

                        Try It Now!
                    </a></div>
                </div>
            </nav>
        </section>

        <section className="engine"><a href="#">website templates</a></section>
        <section className="header5 cid-rYKXTyAteH mbr-fullscreen" id="header5-4">


            <div className="container">
                <div className="row justify-content-center">
                    <div className="mbr-white col-md-10">
                        <h1 className="mbr-section-title align-center pb-3 mbr-fonts-style display-1">Verification
                            Required</h1>
                        <p className="mbr-text align-center display-5 pb-3 mbr-fonts-style">
                            This is the verification section for the requested token if you initiated it you can proceed
                            safely, but if it just poped up some how please <strong><em>report it to us
                            ASAP</em></strong></p>
                        <div className="mbr-section-btn align-center">
                            <a className="btn btn-md btn-secondary display-4">
                                Verify Identity</a>
                            <a className="btn btn-md btn-white-outline display-4" href="#">
                                New User</a></div>
                    </div>
                </div>
            </div>
        </section>

        <section nonce="footers" className="cid-rYL9zWHCpP" id="footer6-d">


            <div className="container">
                <div className="media-container-row align-center mbr-white">
                    <div className="col-12">
                        <p className="mbr-text mb-0 mbr-fonts-style display-7">
                            © Copyright 2020 KeyBlock- All Rights Reserved
                        </p>
                    </div>
                </div>
            </div>
        </section>
        <script src="assets/web/assets/jquery/jquery.min.js"/>
        <script src="assets/popper/popper.min.js"/>
        <script src="assets/bootstrap/js/bootstrap.min.js"/>
        <script src="assets/tether/tether.min.js"/>
        <script src="assets/smoothscroll/smooth-scroll.js"/>
        <script src="assets/dropdown/js/nav-dropdown.js"/>
        <script src="assets/dropdown/js/navbar-dropdown.js"/>
        <script src="assets/touchswipe/jquery.touch-swipe.min.js"/>
        <script src="assets/theme/js/script.js"/>
        </div>





    )
    }

}

export default verificationPage;